import mapActualPack, { RawActualPack } from './mapActualPack';
import VirtualPack from './VirtualPack';

export interface RawVirtualPack {
	id: string;
	distinctName: string;
	dosageStrength: string;
	dosageForm: string;
	packageSize: string;
	packageContainer: string | null;
	real: boolean | null;
	actualPacks: RawActualPack[];
}

export default function mapVirtualPack(virtualPack: RawVirtualPack): VirtualPack {
	return new VirtualPack(
		virtualPack.id,
		virtualPack.distinctName,
		virtualPack.dosageStrength,
		virtualPack.dosageForm,
		virtualPack.packageSize,
		virtualPack.packageContainer,
		Boolean(virtualPack.real),
		virtualPack.actualPacks?.map(mapActualPack) || []
	);
}
